import { keyframes, styled } from "styled-components";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import Select from "react-select";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
`;

export const HomeContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  position: relative;
  min-height: 100dvh;
  height: 100%;
  background: white;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Content = styled.div`
  width: 100%;

  min-height: calc(100dvh - 122px);
  height: 100%;
  padding: 10rem 4rem;

  max-width: 150rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

export const Button = styled.button`
  color: #fff;
  font-family: "FrankfurterEF-Medium";
  font-size: 2.4rem;
  border-radius: 2rem;
  border: 2px solid #484888;
  background: ${(props) => (props.disabled ? "#e9e9e9" : "#484888")};

  display: flex;
  padding: 1rem 2rem;
  justify-content: center;
  align-items: center;
  height: fit-content;
  width: 18rem;
  align-self: center;
  border: none;
  outline: none;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;

export const LoaderContainer = styled.div`
  background: white;
  height: calc(100dvh - 122px);
  width: 100%;
`;

export const HeaderWrapper = styled.header`
  background-color: #fff;

  z-index: 500;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.11);
  position: fixed;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  top: 0;
`;

export const Card = styled.div`
  border-radius: 3rem;
  border: 1px solid #484888;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  height: 100%;
  width: fit-content;
  display: flex;
  flex-direction: column;

  gap: 2rem;
  position: relative;
  padding: 3.2rem 6.4rem;
  @media (max-width: 550px) {
    width: 100%;
    padding: 3.2rem 3.2rem;
  }
`;
export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: center;
  width: 100%;
  margin-top: 1rem;
  justify-content: center;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 6rem;
  height: 6rem;
  border-radius: 1rem;
  background-color: rgba(236, 195, 113, 0.2);
`;

export const Label = styled.span`
  font-family: "Avenir-Medium";
  font-size: 1.2rem;
  letter-spacing: 0.067px;
`;

export const Value = styled.span`
  font-family: "Avenir-Heavy";
  font-size: 3rem;
  letter-spacing: 0.067px;
`;

export const Icon = styled.img`
  width: 3.5rem;
  height: 3.5rem;
  user-select: none;
  pointer-events: none;
`;

export const TextArea = styled.textarea`
  border: ${(props) =>
    props.$error ? "1px solid #FF9494" : "1px solid #8c8c8c"};
  border-radius: 15px;

  user-select: none;
  background: none;
  width: 100%;
  font-weight: 700;
  transition: 0.2s;
  outline: none;
  color: #484888;
  min-height: 12rem;
  &:active,
  &:hover,
  &:focus {
    box-shadow: none;
    color: #000;
    &::placeholder {
      color: #000;
    }
  }

  &::placeholder {
    color: #484888;
  }

  padding: 1.5rem;
  font-family: "Avenir-Medium";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.178px;
  width: 40rem;
  @media (max-width: 600px) {
    width: 100%;
  }
  @media (max-width: 450px) {
    font-size: 14px;
    border-radius: 7.5px;
    height: 39px;
  }
`;
export const Input = styled.input`
  border: ${(props) =>
    props.$error ? "1px solid #FF9494" : "1px solid #8c8c8c"};
  border-radius: 15px;
  height: 60px;
  width: ${(props) => (props.$small ? "25rem" : "40rem")};
  user-select: none;
  background: none;

  font-weight: 700;
  transition: 0.2s;
  outline: none;
  color: #484888;
  &:active,
  &:hover,
  &:focus {
    box-shadow: none;
    color: #000;
    &::placeholder {
      color: #000;
    }
  }

  &::placeholder {
    color: #484888;
  }

  padding: 1.5rem;
  font-family: "Avenir-Medium";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.178px;

  @media (max-width: 600px) {
    width: 100%;
  }
  @media (max-width: 450px) {
    font-size: 14px;
    border-radius: 7.5px;
    height: 39px;
  }
`;

export const SelectStyled = styled(Select)`
  border: ${(props) =>
    props.$error ? "1px solid #FF9494" : "1px solid #8c8c8c"};
  border-radius: 15px;
  height: 60px;
  width: ${(props) => (props.$small ? "25rem" : "40rem")};
  user-select: none;
  background: none;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  transition: 0.2s;
  outline: none;
  color: #484888;
  &:active,
  &:hover,
  &:focus {
    box-shadow: none;
    color: #000;
    &::placeholder {
      color: #000;
    }
  }

  &::placeholder {
    color: #484888;
  }

  padding: 1.5rem;
  font-family: "Avenir-Medium";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.178px;

  @media (max-width: 600px) {
    width: 100%;
  }
  @media (max-width: 450px) {
    font-size: 14px;
    border-radius: 7.5px;
    height: 39px;
  }
`;

export const Title = styled.span`
  color: #454584;
  font-family: "Avenir-Medium";
  font-size: 2.2rem;

  letter-spacing: -0.178px;
`;

export const Subtitle = styled.span`
  font-family: "Avenir-Medium";
  font-size: 1.8rem;
  letter-spacing: -0.178px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;

  justify-content: space-between;
  min-height: 3rem;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Name = styled.span`
  font-family: "Avenir-Medium";

  user-select: none;

  font-size: 18px;
  letter-spacing: -0.177777px;

  color: #484888;
`;

export const Back = styled.span`
  color: #484888;
  text-align: left;
  font-family: "FrankfurterEF-Medium";
  font-size: 2rem;
  letter-spacing: 0.075px;
  text-transform: uppercase;
`;

export const HeaderTitle = styled.span`
  color: #484888;
  text-align: center;
  font-family: "FrankfurterEF-Medium";
  font-size: 5rem;
  letter-spacing: 0.075px;
`;

export const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
  gap: 10rem;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 1227px) {
    flex-direction: column;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  margin-top: 2rem;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const RadioWrapper = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  width: 10rem;
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  width: 22rem;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const UploadText = styled.span`
  color: #484888;
  font-family: "Avenir-Medium";
  font-size: 1.8rem;
  letter-spacing: -0.178px;
  text-decoration-line: underline;
  max-width: 25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: ${(props) => (props.$red ? "pointer" : "default")};
  user-select: none;

  &:hover {
    color: ${(props) => (props.$red ? "red" : "#484888")};
  }
`;

export const UploadContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  width: 25rem;
`;

export const Image = styled.img`
  width: 3rem;
  height: 3rem;
  user-select: none;
  pointer-events: none;
`;

export const AddButton = styled.div`
  width: 3rem;
  height: 3rem;
  background-color: #484888;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-family: "Avenir-Medium";
  font-size: 2rem;
  letter-spacing: -0.178px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
`;

export const Delete = styled(DeleteIcon)`
  cursor: pointer;

  &:hover {
    fill: red;
  }
`;
